module.exports = {"410803001":"李封街道","410803002":"王封街道","410803003":"朱村街道","410803004":"冯封街道","410803005":"龙洞街道","410803006":"月山街道","410803007":"丹河街道","410803008":"许衡街道","410803009":"府城街道","410803010":"龙翔街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410803.json
// module id = 1720
// module chunks = 0